import type Shape from '../objects/Shape';
import { type ShapeName } from '../shapes';
import type ShapeBase from '../shapes/ShapeBase';

// This is here instead of in WhiteboardController to get around circular import
// issues with the WhiteboardController and StylusShape
export const ADVANCED_SHAPES: ShapeName[] = [
  'annotation',
  'progressBar',
  'milestone',
  'timeline',
] as const;

// Orders records from left to right, top to bottom.
export const sortShapesLTR = <T extends ShapeBase>(
  shapes: Shape<T>[]
): Shape<T>[] => {
  const shapesCopy = [...shapes];

  return shapesCopy.sort((a, b) => {
    if (a.left === b.left) {
      return a.top - b.top;
    }
    return a.left - b.left;
  });
};
